export enum CropParameterTypeEnum {
    DEFAULT_BRAPI_SYNC_SOURCE= 'DEFAULT_BRAPI_SYNC_SOURCE',
    STA_BRAPP='STA_BRAPP_URL',
    DECISION_SUPPORT_BRAPP='DS_BRAPP_URL',
    TDE_BRAPP_URL='TDE_BRAPP_URL',
    FIRST_REP_NOT_RANDOMIZED_SWITCH='FIRST_REP_NOT_RANDOMIZED_SWITCH'
}

export enum CropParameterKeys {
    PRECISION_FOR_VALUES_WITH_MAGNITUDE_GREATER_THAN_ONE= 'precision_for_values_with_magnitude_greater_than_one',
    PRECISION_FOR_VALUES_WITH_MAGNITUDE_LESS_THAN_ONE = 'precision_for_values_with_magnitude_less_than_one'
}
